module.exports = __webpack_public_path__ + "img/ic_tripadvisor-1.0.f3eb1892.svg";